// extracted by mini-css-extract-plugin
export default {"root":"ItemStatus_root__zy4YF","done":"ItemStatus_done__aFOTz","todo":"ItemStatus_todo__lfHGR"};